import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=462db41c&scoped=true&"
import script from "./Consultation.vue?vue&type=script&lang=js&"
export * from "./Consultation.vue?vue&type=script&lang=js&"
import style0 from "./Consultation.vue?vue&type=style&index=0&id=462db41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462db41c",
  null
  
)

export default component.exports